/**
 * Shared layout for public pages (Terms, Billing) – matches Strikingly marketing site
 */
import React, { useState } from 'react';
import { Layout } from 'antd';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { MenuOutlined } from '@ant-design/icons';
import './PublicPageLayout.css';
import '../pages/LandingPage.css';

const { Content, Footer } = Layout;

const CONTACT_EMAIL = 'nacsoftwareandtechsolutions26@gmail.com';
const LOGO = `${process.env.PUBLIC_URL || ''}/nac_logo_tight_circle.png`;

interface PublicPageLayoutProps {
  children: React.ReactNode;
}

const PublicPageLayout: React.FC<PublicPageLayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="sk-site public-page-wrapper">
      <header className="sk-header">
        <Link to="/" className="sk-brand" onClick={() => setMobileMenuOpen(false)}>
          <img src={LOGO} alt="NAC" className="sk-logo" />
          <span>NAC Easy Solution</span>
        </Link>
        <nav className="sk-nav" aria-label="Main">
          <NavLink to="/" end>Home</NavLink>
          <NavLink to="/about">About Us</NavLink>
          <NavLink to="/solutions">Solutions</NavLink>
          <NavLink to="/support">Support</NavLink>
          <NavLink to="/blog">Blog &amp; Resources</NavLink>
        </nav>
        <button type="button" className="sk-burger" aria-label="Menu" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          <MenuOutlined />
        </button>
      </header>

      {mobileMenuOpen && (
        <div className="sk-drawer">
          <NavLink to="/" end onClick={() => setMobileMenuOpen(false)}>Home</NavLink>
          <NavLink to="/about" onClick={() => setMobileMenuOpen(false)}>About Us</NavLink>
          <NavLink to="/solutions" onClick={() => setMobileMenuOpen(false)}>Solutions</NavLink>
          <NavLink to="/support" onClick={() => setMobileMenuOpen(false)}>Support</NavLink>
          <NavLink to="/blog" onClick={() => setMobileMenuOpen(false)}>Blog &amp; Resources</NavLink>
          <button type="button" onClick={() => { navigate('/user/login'); setMobileMenuOpen(false); }}>Staff login</button>
          <button type="button" onClick={() => { navigate('/admin/login'); setMobileMenuOpen(false); }}>Admin login</button>
        </div>
      )}

      <Content className="public-page-content">
        {children}
      </Content>

      <Footer className="sk-footer">
        <p>©{new Date().getFullYear()} NAC Software and Tech Solutions. Made in Bhutan.</p>
        <div className="sk-footer-links">
          <Link to="/terms">Terms of Use</Link>
          <Link to="/billing">Billing &amp; Payment</Link>
          <a href={`mailto:${CONTACT_EMAIL}`}>Contact Us</a>
        </div>
      </Footer>
    </div>
  );
};

export default PublicPageLayout;
